import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/css';
export const FractalFLogo = ({ fill = '#fff' }) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 522.5 520.1", width: "1rem", children: _jsx("path", { className: css(`
          fill: ${fill};
        `), d: "M74.9,520.1V0h372.8v112.7h-234v115.6h182V341h-182v179.1H74.9z" }) }));
};
//# sourceMappingURL=fractal-f-logo.js.map